import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useNavigate } from 'react-router-dom'
import { FinanceSpreadsheetWorkroom, DIVISIONS } from './index'

/**
 * Finance Spreadsheet Workroom — route wrapper.
 *
 * Registered standalone + auth-gated (see router.tsx):
 *   /square/command-center/finance/spreadsheet
 *
 * Opened by the Finance division's "Spreadsheet Builder" hot button.
 *
 * Honesty contract: the sheet + chart are a local/visual build. Export .xlsx,
 * Save/Share to system, and Send to Google Sheets are left UNWIRED
 * (no callbacks passed) so they render their honest setup-required states —
 * no fake export, send, or provider sync.
 */
export default function SquareCodeFinanceSpreadsheetRoute() {
  const navigate = useNavigate()
  const finance = DIVISIONS.find((d) => d.id === 'finance') ?? null
  return (
    <FinanceSpreadsheetWorkroom
      sourceDivision={finance}
      onBack={() => navigate(COMMAND_CENTER_ROOT)}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
    />
  )
}
